import { Fragment, useRef, useState, useContext, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { addUser,updateUser } from '../api/api';
import { useTheme } from '../ThemeContext'; // Adjust the path as necessary
import {toast} from 'react-toastify'
export default function AddUser({
  addUserModalSetting,
  setEditing,
  userDetails,
  handlePageUpdate,
  isEditing,
  authContext
}) {
  const { theme } = useTheme(); // Get the theme from context
  const [user, setUser] = useState({
    name: "",
    email: "",
    contact_no: "",
    password: ''
  });
  const[authority,setAuthority]=useState('')
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  const [resume, setResume] = useState('');
  const [resumeFileName, setResumeFileName] = useState('');
  const [id,setId]=useState('')
  useEffect(() => {
    if (isEditing && userDetails) {  // Check if userDetails is defined
      setUser({
        name: userDetails?.name || "",
        email: userDetails?.email || "",
        contact_no: userDetails?.contact_no || "",
        // Password is intentionally left empty for security
        password: ''
      });
      setAuthority(userDetails?.authority || "");
      setResumeFileName(userDetails?.resume || "");
      // Resume file input cannot be prepopulated - just store the filename
    }
  }, [isEditing, userDetails]);  // Add userDetails to dependency array
  
  // Handling Input Change for input fields
  const handleInputChange = (key, value) => {
    setUser({ ...user, [key]: value });
  };

  const handleResume = (e) => {
    setResume(e.target.files[0]);
  };
  // POST Data
  const adduser = async () => {
    if (!user.name || !user.email || !user.contact_no || !authority) {
      toast.error("Please fill in all required fields.");
      return;
    }

    const formData = new FormData();
    formData.append('name', user.name);
    formData.append('email', user.email);
    formData.append('contact_no', user.contact_no);
    formData.append('authority', authority);
    // Only append password if it has a value (for updates)
    if (user.password) {
      formData.append('password', user.password);
    }
    // Only append resume if a new file is selected
    if (resume) {
      formData.append('resume', resume);
    }

    try {
      if(isEditing){
        setId(userDetails?._id)
        const response = await updateUser({id, data:formData});
        //console.log(response)

        if (response.data) {
          toast.success("User Updated successfully!");
          setOpen(false); // Close the modal on success
          setEditing(false)
        }
      }
      else{
        // For new users, resume is required
        if (!resume) {
          toast.error("Please upload a resume.");
          return;
        }
        const response = await addUser(formData)
        if (response.data) {
          toast.success("User added successfully!");
          setOpen(false); // Close the modal on success
          addUserModalSetting();
        }  
      }
    }
    catch (error) {
      console.log(error)
      toast.error("Error adding user!");
    }
    handlePageUpdate()
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className={`relative transform overflow-hidden rounded-lg ${theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'} text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg`}>
                <div className={`${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} px-4 pt-5 pb-4 sm:p-6 sm:pb-4`}>
                  <div className="sm:flex sm:items-start">
                    
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <Dialog.Title as="h3" className="text-lg py-4 text-center font-semibold leading-6">
                       Add User
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-2">
                          <div>
                            <label htmlFor="name" className="block mb-2 text-sm font-medium">
                              Name
                            </label>
                            <input
                              type="text"
                              name="name"
                              id="name"
                              value={user.name}
                              onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                              placeholder="Enter your name"
                            />
                          </div>
                          <div>
                            <label htmlFor="contact_no" className="block mb-2 text-sm font-medium">
                              Contact No.
                            </label>
                            <input
                              type="tel"
                              name="contact_no"
                              id="contact_no"
                              value={user.contact_no}
                              onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                              placeholder="Enter your contact number"
                            />
                          </div>

                          <div>
                            <label htmlFor="email" className="block mb-2 text-sm font-medium">
                              E-mail
                            </label>
                            <input
                              type="email"
                              name="email"
                              id="email"
                              value={user.email}
                              onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                              placeholder="Enter your email"
                            />
                          </div>
                          <div>
                            <label htmlFor="authority" className="block mb-2 text-sm font-medium">
                              Authority
                            </label>
                            <select
                              name="authority"
                              id="authority"
                              value={authority}
                              onChange={(e) => setAuthority(e.target.value)}
                              className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                              ><option value="">Select</option>
                                <option value="superadmin">Superadmin</option>
                                <option value="project_manager">Project Manager</option>
                                <option value="client_side_manager">Client Side Manager</option>
                                <option value="worker">Worker</option>
                          
                              </select>
                          </div>
                          <div>
                            <label htmlFor="password" className="block mb-2 text-sm font-medium">
                              Password {isEditing && <span className="text-gray-500 text-xs">(Leave blank to keep current)</span>}
                            </label>
                            <input
                              type="password"
                              name="password"
                              id="password"
                              value={user.password}
                              onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                              placeholder={isEditing ? "Enter new password to change" : "Enter Password"}
                            />
                          </div>
                          <div>
                            <label className="block mb-2 text-sm font-medium" htmlFor="resume">
                              Resume {isEditing && <span className="text-gray-500 text-xs">(Leave blank to keep current)</span>}
                            </label>
                            {isEditing && resumeFileName && (
                              <div className="mb-2 text-sm text-green-600">
                                Current: {resumeFileName.split('/').pop()}
                              </div>
                            )}
                            <input
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                              type="file"
                              id="resume"
                              name="resume"
                              onChange={handleResume}
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className=" px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse justify-between">
                  <button
                    type="button"
                    onClick={adduser}
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:ml-3 sm:w-auto"
                  >
                    {isEditing?'Save':"Add"}
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:w-auto"
                    onClick={() => {
                      setOpen(false)
                      {isEditing && setEditing(false)}
                    }}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
